import { IconButton, TextField } from "@mui/material";
import { Tune } from "@mui/icons-material";
import { useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { getFeetAndInchesText } from "../../../common/utilities/FeetAndInches";
import { FormFieldPropsBase } from "../form/Form";
import { FormFeetAndInchesPickerPopup } from "./FormFeetAndInchesPickerPopup";
import {isMobile, isTablet} from 'react-device-detect';

export type FormFeetAndInchesPickerProps = {
    maxFeet: number;
    rules?: any;
    onChange?: (totalInches: number | null) => void;
    boldOnDirty?: boolean;
    hideClear?: boolean;
} & FormFieldPropsBase;

export function FormFeetAndInchesPicker({
    name,
    id,
    testId,
    label,
    ariaLabel,
    helperText,
    sx,
    disabled,
    maxFeet,
    rules,
    readOnly,
    onChange,
    boldOnDirty,
    hideClear,
    size
}: FormFeetAndInchesPickerProps) {

    const { control, getValues } = useFormContext();
    const initialValue = getValues(name);
    const [popupOpen, setPopupOpen] = useState<boolean>(false);
    const anchorEl = useRef(undefined);
    //const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
    const isPhone = isMobile && !isTablet;

    return (
        <>
            <Controller
                control={control}
                name={name}
                rules={rules}
                render={
                    ({
                        field: { ref, name, value, onChange: onFieldChange, onBlur },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState
                    }: {
                        field: any;
                        fieldState: any;
                        formState: any;
                    }) => (
                        <>
                            <TextField
                                variant="filled"
                                id={id}
                                name={name}
                                data-testid={testId}
                                aria-label={ariaLabel ?? undefined}
                                label={label ?? undefined}
                                error={invalid}
                                helperText={invalid ? error.message : helperText}
                                onBlur={onBlur}
                                onChange={
                                    (e) => {
                                        const totalInches = Number.parseInt(e.target.value);
                                        onFieldChange(totalInches);
                                        onChange && onChange(totalInches);
                                    }
                                }
                                inputRef={(e) => {
                                    ref(e);
                                    anchorEl.current = e;
                                }}
                                value={getFeetAndInchesText(value)}
                                sx={{
                                    marginTop: 0,
                                    ...sx
                                }}
                                onClick={() => {
                                    if (!disabled && !readOnly) {
                                        setPopupOpen(true);
                                    }
                                }}
                                disabled={disabled}
                                size={size}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                        endAdornment: !isPhone && !readOnly
                                            ? <IconButton disabled={disabled}><Tune /></IconButton>
                                            : undefined,
                                            sx: {
                                                fontWeight: boldOnDirty && isDirty ? 700 : 400
                                            },
                
                                    },

                                    inputLabel: {
                                        shrink: true,
                                    }
                                }} />

                            {anchorEl.current && 
                            <FormFeetAndInchesPickerPopup
                                label={label ?? undefined}
                                totalInches={initialValue}
                                maxFeet={maxFeet}
                                onChange={
                                    (totalInches) => {
                                        onFieldChange(totalInches);
                                        onChange && onChange(totalInches);
                                    }
                                }
                                anchorEl={anchorEl.current}
                                open={popupOpen}
                                onClose={() => setPopupOpen(false)}
                                error={invalid}
                                helperText={invalid ? error.message : helperText}
                                hideClear={hideClear}

                            />
                            }
                        </>
                    )
                }
            />
        </>
    );
}

